export default __webpack_public_path__ + "static/media/alert.797a2fe7.svg";